import React from 'react';
import PropTypes from 'prop-types';

const Info = ({ color = '#B5BDC5' }) => (
    <svg
        width="18px"
        height="18px"
        viewBox="0 0 18 18"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <defs>
            <path
                d="M8.998302,0.00115356451 C3.91294451,0.0794094186 -0.0771052042,4.22696968 0.00113106472,9.15708849 C0.0793673337,14.1654632 3.99118078,18 8.84182946,18 C8.92006573,18 8.92006573,18 8.998302,18 C11.4236263,17.9217441 13.6924781,16.9826739 15.413676,15.2610451 C17.134874,13.5394163 18.0737092,11.2699966 17.9954729,8.84406507 C17.9172367,3.83569041 14.0054232,-0.0771022896 8.998302,0.00115356451 Z M10.0936098,13.4952359 C10.0936098,14.0430269 9.62419215,14.5908178 8.998302,14.5908178 C8.45064811,14.5908178 7.90299423,14.1212827 7.90299423,13.4952359 L7.90299423,8.09558196 C7.90299423,7.54779098 8.37241184,7 8.998302,7 C9.54595588,7 10.0936098,7.46953512 10.0936098,8.09558196 L10.0936098,13.4952359 Z M8.998302,6.08244318 C8.29417557,6.08244318 7.66828542,5.45639635 7.66828542,4.75209367 C7.66828542,4.04779098 8.29417557,3.5 8.998302,3.5 C9.70242842,3.5 10.3283186,4.12604683 10.3283186,4.83034952 C10.2500823,5.53465221 9.70242842,6.08244318 8.998302,6.08244318 Z"
                id="info-path-1"
            />
        </defs>
        <g
            id="Svg-Icons/18px-(All-icons)/info"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <mask id="mask-2" fill="white">
                <use xlinkHref="#info-path-1" />
            </mask>
            <use id="Mask" fill={color} xlinkHref="#info-path-1" />
        </g>
    </svg>
);

Info.propTypes = {
    color: PropTypes.string,
};

export default Info;
